import type { Meta, StoryObj } from "@storybook/react";
import noop from "lodash/noop";

import { fakeGroupClassSeries } from "@/__mocks__/groupClassSeries";
import type { GroupClassSeriesPreviewListProps } from "@/ui/components/groupClasses/series/preview/GroupClassSeriesPreviewList";
import { GroupClassSeriesPreviewList } from "@/ui/components/groupClasses/series/preview/GroupClassSeriesPreviewList";
import { Box, ScreenContainer } from "@/ui/layout";

const StoryMeta: Meta<GroupClassSeriesPreviewListProps> = {
  title: "Components/Group Classes/Series Preview List",
  component: GroupClassSeriesPreviewList,
  argTypes: {
    forWhom: { control: "text" },
    groupClasses: { control: "object" },
    isAppUserSupport: { control: "boolean" },
    isListFetching: { control: "boolean" },
    isListLoading: { control: "boolean" },
    shouldShowViewAllCard: { control: "boolean" },
  },
  args: {
    forWhom: "Olivia",
    groupClasses: [
      fakeGroupClassSeries(),
      fakeGroupClassSeries(),
      fakeGroupClassSeries(),
    ],
    isAppUserSupport: false,
    isListFetching: false,
    isListLoading: false,
    onRefresh: noop,
    shouldShowViewAllCard: true,
    tabSource: "explore",
    variant: "basicGroups",
  },
  render: (args) => {
    return (
      <ScreenContainer isScrollView>
        <Box>
          <GroupClassSeriesPreviewList {...args} />
        </Box>
      </ScreenContainer>
    );
  },
};

type Story = StoryObj<GroupClassSeriesPreviewListProps>;

const Primary: Story = {};

const UserProxy: Story = {
  args: {
    isAppUserSupport: true,
  },
};

export { Primary, UserProxy };
export default StoryMeta;
